import { mutationOptions } from '@tanstack/react-query';
import type { ContentResponse, SaveContentDtoTypeEnum } from '@proposify/document-service-api-client';
import { contentSaveContent } from '@proposify/document-service-api-client';
import { getDocumentServiceSchemaClient } from 'services/api/client';

const ROOT_FOLDER_ID = 'root';

export type SaveContentType = 'SNIPPET' | 'IMAGE' | 'SECTION';

export type SaveContentParams = {
  contentId: string;
  name: string;
  type: SaveContentType;
  folderId: string;
  sourceBlockId?: string;
};

export const saveContent = ({ contentId, name, type, folderId, sourceBlockId }: SaveContentParams): Promise<ContentResponse> => {
  return contentSaveContent(
    contentId,
    {
      name,
      type: type as SaveContentDtoTypeEnum,
      sourceBlockId: sourceBlockId ?? null,
      folderId: folderId === ROOT_FOLDER_ID || folderId === '' ? null : folderId,
    },
    getDocumentServiceSchemaClient()
  );
};

export const saveContentMutation = mutationOptions({
  mutationFn: saveContent,
});
